import { DividerLine } from 'components/smallStatic/Divider/Divider.styled';

const Divider = () => {
  return <DividerLine></DividerLine>;
};

export default Divider;
